import React, { useMemo } from "react";
import { Card, CardContent, CardHeader, Divider, Stack, Typography } from "@mui/material";
import { Client } from "../../apis/clients";
import { useGetRequestsQuery } from "../../apis/requests";
import LineChart from "../Chart/LineChart";
import RequestByTypes from "../Request/RequestByTypes";

interface Props {
  client: Client;
}

const ClientRequest = ({ client }: Props) => {
  const { data: clientRequests } = useGetRequestsQuery(client.id);

  const { labels, data } = useMemo(() => {
    const newLables: string[] = [];
    const newData: number[] = [];

    clientRequests?.data.forEach((req) => {
      newLables.push(req.date);
      newData.push(req.count);
    });

    
    return { labels: newLables, data: newData };
  }, [clientRequests]);

  return (
    <Stack spacing={2}>
      <Typography variant="h6">Total requests</Typography>
      <Typography>{clientRequests?.totalCount}</Typography>
      <Typography variant="h6">Current quota period</Typography>
      <Typography>
        {clientRequests?.period.start} ~ {clientRequests?.period.end}
      </Typography>
      <Card>
        <CardHeader title="Requests timeline" subheader="Last 30 days" />
        <Divider />
        <CardContent>
          <LineChart labels={labels} data={data} />
        </CardContent>
      </Card>
      <RequestByTypes client={client} />
    </Stack>
  );
};

export default ClientRequest;
